// extracted by mini-css-extract-plugin
module.exports = {"itemActive":"InsurancePackageChooser_itemActive__1jA_L","itemInactive":"InsurancePackageChooser_itemInactive__1Uytv","radioImg":"InsurancePackageChooser_radioImg__K9Vyu"};